import React, { useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const ScrollCounter = ({ start, end, duration }) => {
  // State to track whether the counter should start
  const [startCounting, setStartCounting] = useState(false);

  // useInView hook from react-intersection-observer
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger only once when the element is in view
    threshold: 0.5, // Trigger when 50% of the element is visible
  });

  // Start counting when the element is in view
  React.useEffect(() => {
    if (inView) {
      setStartCounting(true);
    }
  }, [inView]);

  return (
    <div>
      <div
        ref={ref}
        className="counter-value"
      >
        {startCounting ? (
          <CountUp start={start} end={end} duration={duration} separator="," />
        ) : (
          <span>Scroll to start the counter</span>
        )}
        <span className="lakhs">Lakhs</span>
      </div>
    </div>
  );
};

export default ScrollCounter;
